import _ from "lodash"
import React, { useEffect, useRef } from "react"
import Isvg from 'react-inlinesvg'
import { AddIcon, DeleteIcon } from "images/icons/tools/"
import { AddRemoveRow_s } from "components/table/carousel/carousel-styles"

import automationService from "data/automation"

type Item_t = {
  i: number
}

type RowAddRemoveProps = {
  emptyRecord: Item_t,
  items: Item_t[],
  row: Item_t,
  persist: Function
}

function isRowFocused(domNode) {
  return domNode.parentElement.contains(document.activeElement)
}

export const RowAddRemove = (props: RowAddRemoveProps) => {
  const ref = useRef<HTMLDivElement|null>()

  useEffect(() => {
    const automationSubscription = automationService.stream().subscribe(event => {
      switch(true) {
        case event.type === "HOTKEY_ADD_ROW":
          if(isRowFocused(_.get(ref, 'current'))) {
            addRow()
          }
          break
        case event.type === "HOTKEY_REMOVE_ROW":
          if(isRowFocused(_.get(ref, 'current'))) {
            removeRow()
          }
          break
      }
    })

    return () => automationSubscription.unsubscribe()
  }, [ref, ref.current])

  const addRow = () => {
    refocus('ADD')
    const { emptyRecord, items, row, persist } = props;
    const i = _.indexOf(items, row) + 1
    let newItems = [...items.slice(0,i), emptyRecord, ...items.slice(i)]
    newItems.forEach((it, i) => it.i = i);
    persist(newItems)
  }

  const removeRow = () => {
    refocus('REMOVE')
    const { items, persist, row, emptyRecord } = props;
    let newItems = _.reject(items, row)
    if (_.isEmpty(newItems)) newItems = [emptyRecord]
    newItems.forEach((it, i) => it.i = i);
    persist(newItems)
  }

  const refocus = (op) => {
    // return
    const i = _.findIndex(props.items, props.row)
    const div = ref.current?.closest('div')
    const rowContainer = div?.closest('.carousel-multi-row')
    const container = rowContainer?.parentElement
    setTimeout(() => automationService.broadcast("CAROUSEL_ROW_ADD_REMOVE", {div, container, rowContainer, i, op}), 200)
  }

  // NB key needed because Isvg was caching click handlers with wrong closure.

  return (
    <AddRemoveRow_s ref={(r) => ref.current = r} key={`row-add-remove-${JSON.stringify(props.items)}`}>
      <div className="carousel-row-add" title="Add Row">
        <Isvg src={AddIcon} onClick={addRow} />
      </div>
      <div className="carousel-row-delete" title="Delete Row">
        <Isvg src={DeleteIcon} onClick={removeRow} />
      </div>
    </AddRemoveRow_s>
  )
}

export default RowAddRemove
